<div class="d-flex pt-48-38 align-items-start">
  @if (showLogo) {
    <img src="assets/img/svg/T.svg" alt="Tracey logo" class="me-3">
  }
  <div class="d-flex align-items-center justify-content-center flex-grow-1">
    <h1 class="fs-44-24 text-center title-wrapper" [class.max-width-350]="setMaxWidth350"
        [class.title-wrapper--remove-transform]="!showLogo">
      {{ title }}
    </h1>
  </div>
</div>
